// @ts-nocheck

import React from 'react';

import { Option, Raw } from '@polkadot/types';
import {
  isFunction,
  isNull,
  isUndefined,
  stringify,
  u8aToHex,
} from '@polkadot/util';
import { parseDataFromContract } from 'utils/common-function';

function div({ className = '', key }, ...values) {
  //console.log('valuesvalues', values);
  return (
    <div className={`ui--Param-text ${className}`} key={key}>
      {values}
    </div>
  );
}

function formatKeys(keys) {
  return JSON.stringify(
    keys.map(([validator, keys]) => [validator.toString(), keys.toHex()]),
  );
}

function toHuman(value) {
  if (isFunction(value.toHuman)) {
    return typeof value.toHuman() === 'string'
      ? value.toHuman().replaceAll(',', '')
      : parseDataFromContract(value.toHuman());
  } else if (Array.isArray(value)) {
    return value.map(v => {
      return toHuman(v);
    });
  }

  return value.toString();
  // return isFunction(value.toHuman)
  //   ?
  //   :
  //   ?
  //   :
}

export function toHumanJson(value) {
  return stringify(value, 2)
    .replace(/,\n/g, '\n')
    .replace(/"/g, '')
    .replace(/\\/g, '')
    .replace(/\],\[/g, '],\n[');
}

export default function valueToText(
  type,
  value,
  returnType = 'obj',
  contentShorten = true,
) {
  if (isNull(value) || isUndefined(value)) {
    return '';
  }

  // if (returnType === 'obj') {
  return ['Bytes', 'Raw', 'Option<Keys>', 'Keys'].includes(type) &&
    isFunction(value.toU8a)
    ? u8aToHex(value.toU8a(true), contentShorten ? 512 : -1)
    : // HACK Handle Keys as hex-only (this should go away once the node value is
    // consistently swapped to `Bytes`)
    type === 'Vec<(ValidatorId,Keys)>'
    ? toHumanJson(formatKeys(value))
    : value instanceof Raw
    ? value.isEmpty
      ? '<empty>'
      : value.toString()
    : value instanceof Option && value.isNone
    ? '<none>'
    : toHuman(value);
  // }

  // return div(
  //   {},
  //   ['Bytes', 'Raw', 'Option<Keys>', 'Keys'].includes(type) &&
  //     isFunction(value.toU8a)
  //     ? u8aToHex(value.toU8a(true), contentShorten ? 512 : -1)
  //     : // HACK Handle Keys as hex-only (this should go away once the node value is
  //     // consistently swapped to `Bytes`)
  //     type === 'Vec<(ValidatorId,Keys)>'
  //     ? toHumanJson(formatKeys(value))
  //     : value instanceof Raw
  //     ? value.isEmpty
  //       ? '<empty>'
  //       : value.toString()
  //     : value instanceof Option && value.isNone
  //     ? '<none>'
  //     : toHumanJson(toHuman(value)),
  // );
}
